import React, { Fragment, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from "../../../../Common/Components/Loading";
import {
  FormSubmitGeneral,
  GetGenralData,
  ShowData,
  checkEmpty,
} from "../Components/Services";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import BoxShadow from "../../../../Common/Components/BoxShadow";
function Create() {
  const modalInfo = [
    {
      component: AboutUsEdit,
      title: "ویرایش درباره ما",
      key: "aboutus",
      btn: "ویرایش درباره ما",
      icon: "fas fa-address-card",
    },
    {
      component: RulesEdit,
      title: "ویرایش قوانین سایت",
      key: "rules",
      btn: "ویرایش قوانین سایت",
      icon: "fas fa-book",
    },
    {
      component: PrivacyEdit,
      title: "ویرایش  حریم خصوصی",
      key: "privacy",
      btn: "ویرایش  حریم خصوصی",
      icon: "fas fa-user-shield",
    },
    {
      component: TargetEdit,
      title: "ویرایش اهداف سایت",
      key: "targets",
      btn: "ویرایش اهداف سایت",
      icon: "fas fa-bullseye",
    },
    {
      component: SocialMedia,
      title: "ویرایش  شبکه های اجتماعی",
      key: "socialmedia",
      btn: "ویرایش  شبکه های اجتماعی",
      icon: "fas fa-retweet",
    },
  ];
  const [state, setstate] = useState({
    loading: true,
    data: null,
  });

  const handler = () => {
    setstate({ ...state, loading: true });
    GetGenralData().then(data => {
      setstate({
        loading: false,
        data: data,
      });
    });
  };
  const submit = () => {
    setstate({ ...state, loading: true });
    FormSubmitGeneral(state).then(() => {
      setstate({ ...state, loading: false });
      handler();
    });
  };
  useEffect(() => {
    handler();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | تنظیمات کلی سایت</title>
      </Helmet>
      <div>
        <div className="card-body">
          <div className="row justify-content-center">
            <h3>تنظیمات کلی سایت</h3>
          </div>
          <div className="row  justify-content-center">
            {state.loading ? (
              <Loading count={1} col={12} height={300} />
            ) : (
              <Fragment>
                <div className="col-md-6 ">
                  {checkEmpty(state.data) ? (
                    modalInfo &&
                    modalInfo.map((modal, key) => {
                      return (
                        <BoxShadow
                          key={key}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                            margin: "0",
                            marginBottom: "10px",
                            cursur: "pointer",
                          }}
                          onClick={() =>
                            setstate({
                              ...state,
                              [modal.key]: true,
                            })
                          }
                        >
                          <div
                            className="btn mx-1 d-flex mb-2  flex-row "
                            style={{ flex: 1 }}
                            onClick={() =>
                              setstate({
                                ...state,
                                [modal.key]: true,
                              })
                            }
                          >
                            <i
                              className={modal.icon}
                              style={{ marginLeft: "10px" }}
                            ></i>
                            <span> {modal.btn}</span>
                          </div>
                          <i className="fas fa-chevron-left px-2"></i>
                        </BoxShadow>
                      );
                    })
                  ) : (
                    <span>اطلاعات موجود نیست</span>
                  )}
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>

      {modalInfo &&
        modalInfo.map((modal, coutn) => (
          <CustomModal
            key={coutn}
            show={state[modal.key]}
            handleClose={() => {
              setstate({ ...state, [modal.key]: false });
            }}
            header={modal.title}
          >
            <modal.component
              key={modal.key}
              data={state.data}
              ShowData={ShowData}
              submit={submit}
              globalState={state}
              globalSetState={setstate}
            />
          </CustomModal>
        ))}
    </Fragment>
  );
}
const AboutUsEdit = ({
  data,
  ShowData,
  submit,
  globalState,
  globalSetState,
}) => {
  return (
    <div className="row">
      <textarea
        className="form-control"
        style={{ height: "450px", resize: "none" }}
        onChange={e => {
          globalSetState({ ...globalState, AboutUs: e.target.value });
        }}
      >
        {ShowData(data, "AboutUs")}
      </textarea>
      <button className="btn btn-danger mt-4" onClick={submit}>
        ثبت تغییرات
      </button>
    </div>
  );
};
const RulesEdit = ({ data, ShowData, submit, globalState, globalSetState }) => {
  return (
    <div className="row">
      <textarea
        className="form-control"
        style={{ height: "450px", resize: "none" }}
        onChange={e => {
          globalSetState({ ...globalState, Rules: e.target.value });
        }}
      >
        {ShowData(data, "Rules")}
      </textarea>
      <button className="btn btn-danger mt-4" onClick={submit}>
        ثبت تغییرات
      </button>
    </div>
  );
};
const PrivacyEdit = ({
  data,
  ShowData,
  globalSetState,
  globalState,
  submit,
}) => {
  return (
    <div className="row">
      <textarea
        className="form-control"
        style={{ height: "450px", resize: "none" }}
        onChange={e => {
          globalSetState({ ...globalState, Privacy: e.target.value });
        }}
      >
        {ShowData(data, "Privacy")}
      </textarea>
      <button className="btn btn-danger mt-4" onClick={submit}>
        ثبت تغییرات
      </button>
    </div>
  );
};
const TargetEdit = ({ data, globalSetState, globalState, submit }) => {
  return (
    <div className="row">
      <textarea
        className="form-control"
        style={{ height: "450px", resize: "none" }}
        onChange={e => {
          globalSetState({ ...globalState, Targets: e.target.value });
        }}
      >
        {ShowData(data, "Targets")}
      </textarea>
      <button className="btn btn-danger mt-4" onClick={submit}>
        ثبت تغییرات
      </button>
    </div>
  );
};
const SocialMedia = ({
  data,
  ShowData,
  globalSetState,
  globalState,
  submit,
}) => {
  return (
    <Fragment>
      <div className="form-group">
        <label>آدرس تلگرام</label>
        <input
          className="form-control"
          id="telegram"
          placeholder="آدرس تلگرام خودرا وارد کنید"
          onChange={e => {
            globalSetState({ ...globalState, Telegram: e.target.value });
          }}
        />
        <small
          id="telegramAddress"
          className="form-text text-muted"
        >{`آدرس فعلی  ${ShowData(data, "Telegram")}`}</small>
      </div>
      <div className="form-group">
        <label>آدرس اینستاگرام</label>
        <input
          className="form-control"
          id="instagram"
          placeholder="آدرس اینستاگرام خودرا وارد کنید"
          onChange={e => {
            globalSetState({ ...globalState, Instagram: e.target.value });
          }}
        />
        <small
          id="instagramAddress"
          className="form-text text-muted"
        >{`آدرس فعلی  ${ShowData(data, "Instagram")}`}</small>
      </div>
      <div className="form-group">
        <label>آدرس لینکدین</label>
        <input
          className="form-control"
          id="linkedin"
          placeholder="آدرس لینکدین خودرا وارد کنید"
          onChange={e => {
            globalSetState({ ...globalState, Linkedin: e.target.value });
          }}
        />
        <small
          id="linkedinAddress"
          className="form-text text-muted"
        >{`آدرس فعلی  ${ShowData(data, "Instagram")}`}</small>
      </div>
      <div className="form-group">
        <label>آدرس توییتر</label>
        <input
          className="form-control"
          id="twitter"
          placeholder="آدرس توییتر خودرا وارد کنید"
          onChange={e => {
            globalSetState({ ...globalState, Twitter: e.target.value });
          }}
        />
        <small
          id="twitterAddress"
          className="form-text text-muted"
        >{`آدرس فعلی  ${ShowData(data, "Instagram")}`}</small>
      </div>
      <button type="submit" className="btn btn-primary" onClick={submit}>
        ثبت تغییرات
      </button>
    </Fragment>
  );
};
export default Create;
